// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/twilight.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/twilight/twilight.js';

mount([g0]);
